module.exports = __webpack_public_path__ + "static/img/2.9728d686.png";